import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectInputModule } from '../../inputs/select/select.module';
import { PurchaseMethodComponent } from './purchase-method.component';

@NgModule({
  declarations: [PurchaseMethodComponent],
  imports: [CommonModule, SelectInputModule],
  exports: [PurchaseMethodComponent],
})
export class PurchaseMethodModule {}
